export default __webpack_public_path__ + "static/media/icon-menu-test.641ceb3b.svg";